// SocialButton.jsx - OAuth provider button matching Figma design
import React from 'react';

const SocialButton = ({
  children,
  icon: Icon,
  iconSrc,
  onClick,
  disabled = false,
  loading = false,
  provider = 'google',
  className = '',
  variant = 'dark',
  ...props
}) => {
  // Matches AuthLayout's variant: the login screen sits on the white gradient.
  const isLight = variant === 'light';
  const surface = isLight
    ? 'bg-white text-[#282A29]'
    : 'bg-[#282a29] text-[#f0f5f2]';
  const hover = isLight
    ? 'hover:bg-[#F1F8F5] hover:border-bloom-green-hover'
    : 'hover:bg-[#2f312f] hover:border-bloom-green-hover';

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || loading}
      aria-busy={loading}
      aria-label={`Continue with ${provider}`}
      className={`w-full h-12 px-4 rounded-[24px] ${surface} border border-bloom-green font-['Inter'] text-[14px] leading-[1.5] transition-all flex items-center gap-3 ${
        disabled || loading ? 'opacity-50 cursor-not-allowed' : hover
      } ${className}`}
      {...props}
    >
      {/* Icon */}
      {loading ? (
        <div className="animate-spin h-5 w-5 border-2 border-bloom-green rounded-full border-t-transparent"></div>
      ) : iconSrc ? (
        <img src={iconSrc} alt={`${provider} icon`} className="w-5 h-5" />
      ) : Icon ? (
        <Icon />
      ) : null}

      {/* Button text */}
      <span className="flex-1 text-left">{children}</span>
    </button>
  );
};

export default SocialButton;
